
export class DepartmentReq{
    department:string
    
    constructor(
        department:string
    ){
        this.department=department
    }
}